// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.search-invoice {
  min-width: 0;
}
.search-invoice h3 {
  margin: 0;
}
.search-invoice .content {
  margin: 1.25rem 1rem;
}
.search-invoice .required-asterisk {
  color: #be123c;
}
.search-invoice .configuration-settings-link {
  margin-left: 0.25rem;
  text-decoration: underline;
}

.invoice-heading {
  padding: 0 1rem;
}
.invoice-heading h2 {
  margin: 0.3rem 0;
  overflow-wrap: anywhere;
}
.invoice-heading p {
  margin: 0.25rem 0;
  color: #475569;
}
.invoice-heading .eyebrow {
  font-size: 0.8rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.settings-heading, .configuration-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.settings-heading {
  margin-bottom: 1rem;
}
.settings-heading p {
  margin: 0;
}

.configuration-summary {
  padding: 1.25rem;
  border: 1px solid #dbe3ec;
  background: #f8fafc;
  border-radius: 8px;
  margin-bottom: 1rem;
}
.configuration-summary p {
  margin: 0.5rem 0;
}

.settings-card, .preparation-card, .period-preview {
  padding: 1.25rem;
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  background: #fff;
  margin: 0 0 1rem;
  min-width: 0;
}

.settings-card h3 {
  font-size: 1.05rem;
  margin-bottom: 1rem;
}

.settings-heading h3 {
  margin-bottom: 0;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;
  margin-top: 1rem;
}

.documents-grid {
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
}

.invoice-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}
.invoice-field label {
  font-weight: 600;
}
.invoice-field input {
  width: 100%;
}
.invoice-field small {
  line-height: 1.5;
  color: #475569;
}
.invoice-field .optional {
  font-weight: 400;
  color: #64748b;
}

.field-error, .invoice-field small.field-error {
  color: #9f1239;
  line-height: 1.5;
}

.inline-fields {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  min-width: 0;
}
.inline-fields p-datepicker {
  flex: 1;
  min-width: 0;
}

.link-button {
  background: none;
  border: 0;
  padding: 0.25rem 0;
  color: #a21d60;
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  text-align: left;
  white-space: normal;
  line-height: 1.5;
}

.link-button:focus-visible, summary:focus-visible {
  outline: 2px solid #db2777;
  outline-offset: 3px;
}

.automation-setting {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 6px;
}
.automation-setting p {
  margin: 0.5rem 0;
}
.automation-setting .checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: 600;
}
.automation-setting input {
  accent-color: #db2777;
  width: 1.1rem;
  height: 1.1rem;
  flex: none;
}
.automation-setting .automation-day {
  max-width: 28rem;
  margin-top: 1rem;
}

details {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}
details summary {
  cursor: pointer;
  font-weight: 600;
}

.preparation-checks {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}
.preparation-checks li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 6px;
  padding: 0.8rem;
  min-width: 0;
  flex-wrap: wrap;
}
.preparation-checks li > i {
  margin-top: 0.2rem;
}
.preparation-checks li > div {
  flex: 1;
  min-width: 120px;
}
.preparation-checks small {
  display: block;
  margin-top: 0.4rem;
  line-height: 1.5;
}
.preparation-checks .check-ready {
  color: #166534;
  border-color: #bbdec8;
}
.preparation-checks .check-blocked {
  color: #854d0e;
  border-color: #e9d9b0;
}

.missing-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  margin-top: 1rem;
}

.period-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem 1.5rem;
  margin: 1rem 0;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 6px;
}

.configuration-actions {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #fff;
  box-shadow: 0 -4px 16px rgba(15, 23, 42, 0.0509803922);
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
}

.save-state {
  flex: 1;
  min-width: 200px;
}
.save-state small {
  display: block;
  color: #475569;
  line-height: 1.5;
  margin-top: 0.3rem;
}
.save-state strong {
  color: #854d0e;
}

.action {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.document-context {
  display: flex;
  gap: 0.5rem 1.25rem;
  flex-wrap: wrap;
  padding-bottom: 1rem;
}
.document-context strong {
  width: 100%;
  font-size: 1.1rem;
}
.document-context span {
  overflow-wrap: anywhere;
}

.zip-inventory {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  background: #f8fafc;
  padding: 1rem;
  border: 1px solid #dbe3ec;
  border-radius: 6px;
}
.zip-inventory ul {
  padding-left: 1.25rem;
  margin: 0.5rem 0 0;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.preview-tabs {
  display: flex;
  gap: 1rem;
  border-bottom: 1px solid #cbd5e1;
  margin: 1rem 0;
}
.preview-tabs button {
  padding: 0.8rem 0.5rem;
  background: none;
  border: 0;
  border-bottom: 3px solid transparent;
  font: inherit;
  cursor: pointer;
}
.preview-tabs button[aria-selected=true] {
  border-bottom-color: #db2777;
  color: #9d174d;
  font-weight: 600;
}
.preview-tabs button:disabled {
  color: #64748b;
  cursor: default;
}
.preview-tabs button:focus-visible {
  outline: 2px solid #db2777;
  outline-offset: -2px;
}

.pdf-preview {
  border: 0;
  width: 100%;
  height: 65vh;
  min-height: 350px;
}

.email-metadata {
  display: grid;
  grid-template-columns: 10rem minmax(0, 1fr);
  gap: 0.5rem;
}
.email-metadata dt {
  font-weight: 600;
}
.email-metadata dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.test-email {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #dbe3ec;
  border-radius: 6px;
}
.test-email .invoice-field {
  flex: 1;
  min-width: 200px;
}

.excel-file-picker {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1200px) {
  .settings-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 700px) {
  .search-invoice .content {
    margin: 0.75rem 0;
  }
  .settings-grid, .documents-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .settings-card, .preparation-card, .period-preview {
    padding: 1rem;
  }
  .configuration-actions {
    position: static;
  }
  .action {
    width: 100%;
    justify-content: flex-end;
  }
  .email-metadata {
    grid-template-columns: 1fr;
  }
  .email-metadata dt {
    margin-top: 0.5rem;
  }
  .preview-tabs {
    gap: 0.5rem;
  }
  .preparation-checks {
    grid-template-columns: 1fr;
  }
}
.generation-result {
  margin: 1rem;
  padding: 0.75rem 1rem;
  border: 1px solid #9fd4b2;
  border-radius: 0.25rem;
  color: #1f6f43;
  background: #eaf7ef;
}
.generation-result p {
  margin: 0;
}
.generation-result p + p {
  margin-top: 0.5rem;
}
.generation-result--warning {
  color: #7b5b00;
  border-color: #f0d48f;
  background: #fff7e6;
}
.generation-result.p-error {
  color: #8d1f1f;
  border-color: #f0a5a5;
  background: #fff0f0;
}

.period-preview-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.period-preview-dates {
  white-space: nowrap;
}

.period-preview-partner {
  margin-bottom: 1rem;
}
.period-preview-partner:last-child {
  margin-bottom: 0;
}

.period-preview-contract {
  margin-top: 0.5rem;
  font-size: 0.875rem;
}

/* Actions d'une ligne de génération : l'écart et le repli viennent de \`.table-actions\`
   (global), seul le ferrage à droite est propre à ce tableau. */
.generation-actions {
  justify-content: flex-end;
}

.generation-details-wrapper {
  padding: 0.25rem 0 0.5rem 0;
}

.generation-excel-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.generation-excel-file-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  align-items: center;
}

.generation-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border-radius: 999px;
  padding: 0.125rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid #d7dee6;
  color: #455a64;
  background: #f7f9fb;
}

.generation-status-badge--valid {
  color: #1f6f43;
  border-color: #9fd4b2;
  background: #eaf7ef;
}

.generation-status-badge--pending {
  color: #7b5b00;
  border-color: #f0d48f;
  background: #fff7e6;
}

.generation-status-badge--sent {
  color: #085f63;
  border-color: #8ed5d8;
  background: #e7f7f8;
}

.generation-status-badge--error {
  color: #8d1f1f;
  border-color: #f0a5a5;
  background: #fff0f0;
}

.generation-status-badge--scheduled {
  color: #385898;
  border-color: #b7c7e8;
  background: #edf3ff;
}

@media (max-width: 991px) {
  .generation-actions {
    justify-content: flex-start;
  }
  .generation-excel-actions {
    justify-content: flex-start;
  }
}
.alert-recipients {
  margin-top: 1.25rem;
}

.incident-section {
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  background: #fff;
}

.incident-card {
  border-left: 4px solid #be123c;
  padding: 1rem;
  margin-top: 1rem;
  background: #fff7f8;
  overflow-wrap: anywhere;
}

.incident-card p {
  line-height: 1.5;
}

.incident-card small {
  display: block;
  margin: 0.5rem 0;
}

.incident-resolved {
  border-left-color: #15803d;
  background: #f0fdf4;
}

.product-status-selector {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.6rem;
}

.booking-status-option {
  max-width: min(38rem, 75vw);
  white-space: normal;
}
.booking-status-option strong {
  display: block;
  font-weight: 500;
}
.booking-status-option small {
  display: block;
  color: #64748b;
  margin-top: 0.25rem;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/invoicing/invoice/search-invoice/search-invoice.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,YAAA;AAEJ;AADI;EACI,SAAA;AAGR;AADI;EACI,oBAAA;AAGR;AADI;EACI,cAAA;AAGR;AADI;EACI,oBAAA;EACA,0BAAA;AAGR;;AACA;EACI,eAAA;AAEJ;AADI;EACI,gBAAA;EACA,uBAAA;AAGR;AADI;EACI,iBAAA;EACA,cAAA;AAGR;AADI;EACI,iBAAA;EACA,sBAAA;EACA,yBAAA;AAGR;;AACA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;AADI;EACI,SAAA;AAGR;;AACA;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAEJ;AADI;EACI,gBAAA;AAGR;;AACA;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAEJ;;AACA;EACI,kBAAA;EACA,mBAAA;AAEJ;;AACA;EACI,gBAAA;AAEJ;;AACA;EACI,aAAA;EACA,gDAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AACA;EACI,oDAAA;AAEJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAEJ;AADI;EACI,gBAAA;AAGR;AADI;EACI,WAAA;AAGR;AADI;EACI,gBAAA;EACA,cAAA;AAGR;AADI;EACI,gBAAA;EACA,cAAA;AAGR;;AACA;EACI,cAAA;EACA,gBAAA;AAEJ;;AACA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AAEJ;AADI;EACI,OAAA;EACA,YAAA;AAGR;;AACA;EACI,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,0BAAA;EACA,mBAAA;AAEJ;;AACA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;AADI;EACI,gBAAA;AAGR;AADI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAGR;AADI;EACI,qBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;AAGR;AADI;EACI,gBAAA;EACA,gBAAA;AAGR;;AACA;EACI,gBAAA;EACA,iBAAA;EACA,6BAAA;AAEJ;AADI;EACI,eAAA;EACA,gBAAA;AAGR;;AACA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,2DAAA;EACA,YAAA;AAEJ;AADI;EACI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAGR;AADI;EACI,kBAAA;AAGR;AADI;EACI,OAAA;EACA,gBAAA;AAGR;AADI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AAGR;AADI;EACI,cAAA;EACA,qBAAA;AAGR;AADI;EACI,cAAA;EACA,qBAAA;AAGR;;AACA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,sDAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;AAEJ;;AACA;EACI,OAAA;EACA,gBAAA;AAEJ;AADI;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAGR;AADI;EACI,cAAA;AAGR;;AACA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAEJ;AADI;EACI,WAAA;EACA,iBAAA;AAGR;AADI;EACI,uBAAA;AAGR;;AACA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAEJ;AADI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAGR;;AACA;EACI,aAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;AAEJ;AADI;EACI,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;AAGR;AADI;EACI,4BAAA;EACA,cAAA;EACA,gBAAA;AAGR;AADI;EACI,cAAA;EACA,eAAA;AAGR;AADI;EACI,0BAAA;EACA,oBAAA;AAGR;;AACA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAEJ;;AACA;EACI,aAAA;EACA,2CAAA;EACA,WAAA;AAEJ;AADI;EACI,gBAAA;AAGR;AADI;EACI,SAAA;EACA,uBAAA;AAGR;;AACA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAEJ;AADI;EACI,OAAA;EACA,gBAAA;AAGR;;AACA;EACI,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAEJ;;AACA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAEJ;;AACA;EACI;IACI,gDAAA;EAEN;AACF;AACA;EACI;IACI,iBAAA;EACN;EACE;IACI,qCAAA;EACN;EACE;IACI,aAAA;EACN;EACE;IACI,gBAAA;EACN;EACE;IACI,WAAA;IACA,yBAAA;EACN;EACE;IACI,0BAAA;EACN;EAAM;IACI,kBAAA;EAEV;EACE;IACI,WAAA;EACN;EACE;IACI,0BAAA;EACN;AACF;AAEA;EACI,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAAJ;AAEI;EACI,SAAA;AAAR;AAEQ;EACI,kBAAA;AAAZ;AAII;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AAFR;AAKI;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AAHR;;AAOA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAJJ;;AAOA;EACI,mBAAA;AAJJ;;AAOA;EACI,mBAAA;AAJJ;AAMI;EACI,gBAAA;AAJR;;AAQA;EACI,kBAAA;EACA,mBAAA;AALJ;;AAQA;gEAAA;AAEA;EACI,yBAAA;AALJ;;AAQA;EACI,2BAAA;AALJ;;AAQA;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AALJ;;AAQA;EACI,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AALJ;;AAQA;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AALJ;;AAQA;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AALJ;;AAQA;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AALJ;;AAQA;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AALJ;;AAQA;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AALJ;;AAQA;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AALJ;;AAQA;EACI;IACI,2BAAA;EALN;EAQE;IACI,2BAAA;EANN;AACF;AASA;EAAoB,mBAAA;AANpB;;AAOA;EAAoB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;EAAqB,gBAAA;AAC1G;;AAAA;EAAiB,8BAAA;EAAgC,aAAA;EAAe,gBAAA;EAAkB,mBAAA;EAAqB,uBAAA;AAQvG;;AAPA;EAAmB,gBAAA;AAWnB;;AAVA;EAAuB,cAAA;EAAgB,gBAAA;AAevC;;AAdA;EAAqB,0BAAA;EAA4B,mBAAA;AAmBjD;;AAjBA;EAA2B,aAAA;EAAe,sBAAA;EAAwB,WAAA;EAAY,kBAAA;AAwB9E;;AAvBA;EAAyB,2BAAA;EAA6B,mBAAA;AA4BtD;AA5B2E;EAAS,cAAA;EAAgB,gBAAA;AAgCpG;AAhCwH;EAAQ,cAAA;EAAgB,cAAA;EAAgB,mBAAA;AAqChK;AACA,gmqBAAgmqB","sourcesContent":[".search-invoice {\n    min-width: 0;\n    h3 {\n        margin:0;\n    }\n    .content {\n        margin:1.25rem 1rem;\n    }\n    .required-asterisk {\n        color:#be123c;\n    }\n    .configuration-settings-link {\n        margin-left: .25rem;\n        text-decoration:underline;\n    }\n}\n\n.invoice-heading {\n    padding: 0 1rem;\n    h2 {\n        margin: .3rem 0;\n        overflow-wrap:anywhere;\n    }\n    p {\n        margin: .25rem 0;\n        color:#475569;\n    }\n    .eyebrow {\n        font-size: .8rem;\n        letter-spacing: .06em;\n        text-transform:uppercase;\n    }\n}\n\n.settings-heading,.configuration-summary {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    flex-wrap:wrap;\n}\n\n.settings-heading {\n    margin-bottom: 1rem;\n    p {\n        margin:0;\n    }\n}\n\n.configuration-summary {\n    padding: 1.25rem;\n    border: 1px solid #dbe3ec;\n    background: #f8fafc;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    p {\n        margin:.5rem 0;\n    }\n}\n\n.settings-card,.preparation-card,.period-preview {\n    padding: 1.25rem;\n    border: 1px solid #dbe3ec;\n    border-radius: 8px;\n    background: #fff;\n    margin: 0 0 1rem;\n    min-width:0;\n}\n\n.settings-card h3 {\n    font-size: 1.05rem;\n    margin-bottom:1rem;\n}\n\n.settings-heading h3 {\n    margin-bottom:0;\n}\n\n.settings-grid {\n    display: grid;\n    grid-template-columns: repeat(3,minmax(0,1fr));\n    gap: 1.25rem;\n    margin-top:1rem;\n}\n\n.documents-grid {\n    grid-template-columns:minmax(0,1fr) minmax(0,2fr);\n}\n\n.invoice-field {\n    display: flex;\n    flex-direction: column;\n    gap: .5rem;\n    min-width: 0;\n    label {\n        font-weight:600;\n    }\n    input {\n        width:100%;\n    }\n    small {\n        line-height: 1.5;\n        color:#475569;\n    }\n    .optional {\n        font-weight: 400;\n        color:#64748b;\n    }\n}\n\n.field-error,.invoice-field small.field-error {\n    color: #9f1239;\n    line-height:1.5;\n}\n\n.inline-fields {\n    display: flex;\n    gap: .5rem;\n    align-items: center;\n    min-width: 0;\n    p-datepicker {\n        flex: 1;\n        min-width:0;\n    }\n}\n\n.link-button {\n    background: none;\n    border: 0;\n    padding: .25rem 0;\n    color: #a21d60;\n    font: inherit;\n    text-decoration: underline;\n    text-underline-offset: 3px;\n    cursor: pointer;\n    text-align: left;\n    white-space: normal;\n    line-height:1.5;\n}\n\n.link-button:focus-visible,summary:focus-visible {\n    outline: 2px solid #db2777;\n    outline-offset:3px;\n}\n\n.automation-setting {\n    margin-top: 1rem;\n    padding: 1rem;\n    background: #f8fafc;\n    border-radius: 6px;\n    p {\n        margin:.5rem 0;\n    }\n    .checkbox-label {\n        display: flex;\n        align-items: center;\n        gap: .6rem;\n        font-weight:600;\n    }\n    input {\n        accent-color: #db2777;\n        width: 1.1rem;\n        height: 1.1rem;\n        flex:none;\n    }\n    .automation-day {\n        max-width: 28rem;\n        margin-top:1rem;\n    }\n}\n\ndetails {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e2e8f0;\n    summary {\n        cursor: pointer;\n        font-weight:600;\n    }\n}\n\n.preparation-checks {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fit,minmax(200px,1fr));\n    gap: .75rem;\n    li {\n        display: flex;\n        align-items: flex-start;\n        gap: .6rem;\n        border: 1px solid #e2e8f0;\n        background: #f8fafc;\n        border-radius: 6px;\n        padding: .8rem;\n        min-width: 0;\n        flex-wrap:wrap;\n    }\n    li>i {\n        margin-top:.2rem;\n    }\n    li>div {\n        flex: 1;\n        min-width:120px;\n    }\n    small {\n        display: block;\n        margin-top: .4rem;\n        line-height:1.5;\n    }\n    .check-ready {\n        color: #166534;\n        border-color:#bbdec8;\n    }\n    .check-blocked {\n        color: #854d0e;\n        border-color:#e9d9b0;\n    }\n}\n\n.missing-fields {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: .5rem 1rem;\n    margin-top:1rem;\n}\n\n.period-counts {\n    display: flex;\n    flex-wrap: wrap;\n    gap: .6rem 1.5rem;\n    margin: 1rem 0;\n    padding: .75rem;\n    background: #f8fafc;\n    border-radius:6px;\n}\n\n.configuration-actions {\n    position: sticky;\n    bottom: 0;\n    z-index: 2;\n    background: #fff;\n    box-shadow: 0 -4px 16px #0f172a0d;\n    border: 1px solid #dbe3ec;\n    border-radius: 8px;\n    padding: 1rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    flex-wrap: wrap;\n    margin-bottom:1.5rem;\n}\n\n.save-state {\n    flex: 1;\n    min-width: 200px;\n    small {\n        display: block;\n        color: #475569;\n        line-height: 1.5;\n        margin-top:.3rem;\n    }\n    strong {\n        color:#854d0e;\n    }\n}\n\n.action {\n    display: flex;\n    gap: .75rem;\n    align-items: center;\n    flex-wrap:wrap;\n}\n\n.document-context {\n    display: flex;\n    gap: .5rem 1.25rem;\n    flex-wrap: wrap;\n    padding-bottom: 1rem;\n    strong {\n        width: 100%;\n        font-size:1.1rem;\n    }\n    span {\n        overflow-wrap:anywhere;\n    }\n}\n\n.zip-inventory {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    flex-wrap: wrap;\n    background: #f8fafc;\n    padding: 1rem;\n    border: 1px solid #dbe3ec;\n    border-radius: 6px;\n    ul {\n        padding-left: 1.25rem;\n        margin: .5rem 0 0;\n        line-height: 1.6;\n        overflow-wrap:anywhere;\n    }\n}\n\n.preview-tabs {\n    display: flex;\n    gap: 1rem;\n    border-bottom: 1px solid #cbd5e1;\n    margin: 1rem 0;\n    button {\n        padding: .8rem .5rem;\n        background: none;\n        border: 0;\n        border-bottom: 3px solid transparent;\n        font: inherit;\n        cursor:pointer;\n    }\n    button[aria-selected=true] {\n        border-bottom-color: #db2777;\n        color: #9d174d;\n        font-weight:600;\n    }\n    button:disabled {\n        color: #64748b;\n        cursor:default;\n    }\n    button:focus-visible {\n        outline: 2px solid #db2777;\n        outline-offset:-2px;\n    }\n}\n\n.pdf-preview {\n    border: 0;\n    width: 100%;\n    height: 65vh;\n    min-height:350px;\n}\n\n.email-metadata {\n    display: grid;\n    grid-template-columns: 10rem minmax(0,1fr);\n    gap: .5rem;\n    dt {\n        font-weight:600;\n    }\n    dd {\n        margin: 0;\n        overflow-wrap:anywhere;\n    }\n}\n\n.test-email {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    flex-wrap: wrap;\n    margin-top: 1rem;\n    padding: 1rem;\n    border: 1px solid #dbe3ec;\n    border-radius: 6px;\n    .invoice-field {\n        flex: 1;\n        min-width:200px;\n    }\n}\n\n.excel-file-picker {\n    display: flex;\n    gap: .5rem;\n    flex-wrap: wrap;\n    margin-bottom:1rem;\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0,0,0,0);\n    white-space: nowrap;\n    border:0;\n}\n\n@media(max-width:1200px) {\n    .settings-grid {\n        grid-template-columns:repeat(2,minmax(0,1fr));\n    }\n}\n\n@media(max-width:700px) {\n    .search-invoice .content {\n        margin:.75rem 0;\n    }\n    .settings-grid,.documents-grid {\n        grid-template-columns:minmax(0,1fr);\n    }\n    .settings-card,.preparation-card,.period-preview {\n        padding:1rem;\n    }\n    .configuration-actions {\n        position:static;\n    }\n    .action {\n        width: 100%;\n        justify-content:flex-end;\n    }\n    .email-metadata {\n        grid-template-columns: 1fr;\n        dt {\n            margin-top:.5rem;\n        }\n    }\n    .preview-tabs {\n        gap:.5rem;\n    }\n    .preparation-checks {\n        grid-template-columns:1fr;\n    }\n}\n\n.generation-result {\n    margin: 1rem;\n    padding: 0.75rem 1rem;\n    border: 1px solid #9fd4b2;\n    border-radius: 0.25rem;\n    color: #1f6f43;\n    background: #eaf7ef;\n\n    p {\n        margin: 0;\n\n        + p {\n            margin-top: 0.5rem;\n        }\n    }\n\n    &--warning {\n        color: #7b5b00;\n        border-color: #f0d48f;\n        background: #fff7e6;\n    }\n\n    &.p-error {\n        color: #8d1f1f;\n        border-color: #f0a5a5;\n        background: #fff0f0;\n    }\n}\n\n.period-preview-heading {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.period-preview-dates {\n    white-space: nowrap;\n}\n\n.period-preview-partner {\n    margin-bottom: 1rem;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n\n.period-preview-contract {\n    margin-top: 0.5rem;\n    font-size: 0.875rem;\n}\n\n/* Actions d'une ligne de génération : l'écart et le repli viennent de `.table-actions`\n   (global), seul le ferrage à droite est propre à ce tableau. */\n.generation-actions {\n    justify-content: flex-end;\n}\n\n.generation-details-wrapper {\n    padding: 0.25rem 0 0.5rem 0;\n}\n\n.generation-excel-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n.generation-excel-file-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    align-items: center;\n}\n\n.generation-status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    border-radius: 999px;\n    padding: 0.125rem 0.625rem;\n    font-size: 0.75rem;\n    font-weight: 600;\n    border: 1px solid #d7dee6;\n    color: #455a64;\n    background: #f7f9fb;\n}\n\n.generation-status-badge--valid {\n    color: #1f6f43;\n    border-color: #9fd4b2;\n    background: #eaf7ef;\n}\n\n.generation-status-badge--pending {\n    color: #7b5b00;\n    border-color: #f0d48f;\n    background: #fff7e6;\n}\n\n.generation-status-badge--sent {\n    color: #085f63;\n    border-color: #8ed5d8;\n    background: #e7f7f8;\n}\n\n.generation-status-badge--error {\n    color: #8d1f1f;\n    border-color: #f0a5a5;\n    background: #fff0f0;\n}\n\n.generation-status-badge--scheduled {\n    color: #385898;\n    border-color: #b7c7e8;\n    background: #edf3ff;\n}\n\n@media (max-width: 991px) {\n    .generation-actions {\n        justify-content: flex-start;\n    }\n\n    .generation-excel-actions {\n        justify-content: flex-start;\n    }\n}\n\n.alert-recipients { margin-top: 1.25rem; }\n.incident-section { border: 1px solid #dbe3ec; border-radius: 8px; padding: 1.25rem; margin-bottom: 1rem; background: #fff; }\n.incident-card { border-left: 4px solid #be123c; padding: 1rem; margin-top: 1rem; background: #fff7f8; overflow-wrap: anywhere; }\n.incident-card p { line-height: 1.5; }\n.incident-card small { display: block; margin: .5rem 0; }\n.incident-resolved { border-left-color: #15803d; background: #f0fdf4; }\n\n.product-status-selector { display: flex; flex-direction: column; gap: .4rem; margin-top: .6rem; }\n.booking-status-option { max-width: min(38rem, 75vw); white-space: normal; strong { display: block; font-weight: 500; } small { display: block; color: #64748b; margin-top: .25rem; } }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
